import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Avatar,
} from "@mui/material";
import { Logout } from "@mui/icons-material";
import { IRootState } from "../../store/configureStore";
import { logout } from "../../store/actions/auth.action";
import Stack from "@mui/material/Stack";
import { NotificationsPopover } from "../messages/notifications-popover";
import { MessagesPopover } from "../messages/messages-popover";

interface IProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserDetails = (props: IProps) => {
  const dispatch: any = useDispatch();
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const { profile } = useSelector(({ privileges }: IRootState) => ({
    profile: privileges.dataBundleUser,
  }));

  const logoutHandler = () => {
    dispatch(logout());
    setShowConfirmation(false);
  };

  const customerId = profile?.customer.id;
  const userId = profile?.id;
  const userName = profile?.username;

  if (customerId !== undefined) {
    localStorage.setItem("CustomerID", customerId.toString());
  }
  if (userName !== undefined) {
    localStorage.setItem("UserName", userName.toString());
  }
  if (userId !== undefined) {
    localStorage.setItem("UserID", userId.toString());
  }
  return (
    <Box p={2} display="flex" flexDirection="column">
      <Grid container alignItems="center" justifyContent="center" spacing={3}>
        {/* Profile Avatar */}
        <Grid item xs={12} md="auto" textAlign="center">
          <Stack spacing={2} alignItems="center">
            <Stack
              direction={{ xs: "row", sm: "row" }}
              spacing={{ xs: 1, sm: 2, md: 4 }}
            >
              {/* Profile Avatar */}
              <Avatar
                alt={profile?.customer.name}
                src="/path/to/userAlt.png"
                sx={{
                  width: { xs: 60, sm: 70 },
                  height: { xs: 60, sm: 70 },
                  marginBottom: 2,
                  background: `linear-gradient(to right,rgb(199, 230, 183),rgb(64, 210, 255))`,
                }}
              />
              <Grid item xs={12} md="auto" textAlign="left">
                {/* User Info */}
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: 11, sm: 18 },
                    maxWidth: "25ch",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordBreak: "break-word",
                    lineHeight: 1.2,
                  }}
                >
                  {profile?.customer.name || "User Name"}
                </Typography>
                <Typography
                  variant="body2"
                  fontSize={14}
                  color="textSecondary"
                  sx={{ fontSize: { xs: 11, sm: 15 } }}
                >
                  Username: {profile?.username || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontSize: { xs: 11, sm: 15 } }}
                >
                  Role: {profile?.role.name || "N/A"}
                </Typography>
              </Grid>
            </Stack>
          </Stack>
          <Stack
            spacing={4}
            direction="row"
            alignItems="center"
            justifyContent="left"
            sx={{ marginTop: 3 }}
          >
            {/* Email Notifications */}
            <Stack spacing={3} direction="row">
              {/* <Badge
                badgeContent={4}
                color="secondary"
                sx={{ margin: "0 10px" }}
              >
                <NotificationsIcon sx={{ color: "#00B4EB" }} />
              </Badge> */}
              <div style={{ margin: "0px" }}>
                <NotificationsPopover />
              </div>
              <div style={{ margin: "0px" }}>
                <MessagesPopover />
              </div>

              {/* <Badge
                badgeContent={66}
                color="success"
                sx={{ margin: "0 10px" }}
              >
                <ChatIcon sx={{ color: "#51B848" }} />
              </Badge> */}
            </Stack>
            {/* Logout Button */}
            <Button
              startIcon={<Logout />}
              sx={{
                borderRadius: 2,
                paddingX: { xs: 1, sm: 3 },
                backgroundColor: "#FFFFFF",
                boxShadow: "0px 5px 5px rgba(3, 160, 184, 0.07)",
                color: "#1E4894",
                fontSize: { xs: 11, sm: 15 },
                fontWeight: 600,
                "&:hover": { backgroundColor: "#C4C4C4" },
              }}
              onClick={() => setShowConfirmation(true)}
            >
              Sign Out
            </Button>
          </Stack>
        </Grid>
      </Grid>

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "15px",
            padding: "20px",
            maxWidth: "400px",
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1.2rem",
            color: "#333",
          }}
        >
          <Typography variant="h6" component="div">
            Logout Confirmation
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", padding: "20px 40px" }}>
          <Typography
            variant="body1"
            sx={{ marginBottom: "20px", color: "#555" }}
          >
            Are you sure you want to log out?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "center", padding: "0 20px 20px 20px" }}
        >
          <Button
            onClick={() => setShowConfirmation(false)}
            color="success"
            variant="outlined"
            sx={{
              borderRadius: "20px",
              padding: "10px 20px",
              fontWeight: "600",
              textTransform: "none",
              borderColor: "#51B848",
              "&:hover": {
                borderColor: "#51B848",
              },
            }}
          >
            No
          </Button>
          <Button
            onClick={logoutHandler}
            color="primary"
            variant="contained"
            sx={{
              borderRadius: "20px",
              padding: "10px 20px",
              fontWeight: "600",
              textTransform: "none",
              backgroundColor: "#1E4894",
              "&:hover": {
                backgroundColor: "#1E4894",
              },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UserDetails;
